import React from "react";
import { Text } from "react-native";
import { convert } from "../locale/translateText";

const FormTextLabel = ({ label, labelStyles, labelClass, rest, onPress, children, key }) => {
  label = convert(label, rest);  
  return <Text key={key} onPress={onPress} style={labelStyles}>{label}{children}</Text>;
};

export default FormTextLabel;
